import { AnalyticsEmptyOptions, FilterType, IAnalyticsSettingsOptions } from "@/types/IAnalytics"

export interface AnalyticsHelpersProps {
}

export interface ITotalNumberAnalytics {
  key: string
  value: number
}

export const useAnalyticsHelpers = (props: AnalyticsHelpersProps) => {

  const getTotalNumberAnalytics = (data: any[]) => {
    const array: ITotalNumberAnalytics[] = []
    if (data && data.length > 0) {
      Object.entries(data[0]).forEach(([key, value]) => {
        if (typeof value === "number") {
          array.push({ key, value: parseFloat(data.map(x => x[key as keyof any] as number).reduce((a, n) => (a + n), 0).toFixed(3)) })
        }
      })
    }
    return array
  }

  const isFilterTypeSetOn = (filters: FilterType[] | undefined, filterType: FilterType) => {
      return filters && filters.some(f => f === filterType)
  }

  const parseDateFromString = (dateStr: string, delimeter: string = "."): Date => {
    const [day, month, year] = dateStr.split(delimeter).map(Number)
    return new Date(year, month - 1, day) // Month is zero-based
  }

  const parseDateFromStringStartFromYear = (dateStr: string, delimeter: string = "."): Date => {
    const [year, month, day] = dateStr.split(delimeter).map(Number)
    return new Date(year, month - 1, day) // Month is zero-based
  }

  const deepCopyOptionsObject = (initialObject: IAnalyticsSettingsOptions[]): IAnalyticsSettingsOptions[] => {
    const result : IAnalyticsSettingsOptions[] = []
    initialObject.forEach(obj => {
      const copy = JSON.stringify(obj, Object.getOwnPropertyNames(obj))
      result.push({ ...AnalyticsEmptyOptions, ...JSON.parse(copy) })
    })
    return result
  }

  return {
    getTotalNumberAnalytics,
    isFilterTypeSetOn,
    parseDateFromString,
    parseDateFromStringStartFromYear,
    deepCopyOptionsObject
  }
}
